var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_c('h6',{staticClass:"pull-left column-title"},[_vm._v(" "+_vm._s(_vm.props.title)+" "),_c('span',{staticClass:"item-count"},[_vm._v("("+_vm._s(_vm.props.count)+")")])]),_c('div',{staticClass:"pull-left pl-3"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }